import { validUrlAnchors } from 'constants/validUrlAnchors';
import { persistPostAuthRedirectFromRaw } from 'utils/postAuthRedirect';
import { saveToStorage } from './token';

const normalizeAnchor = (anchor: string): string => {
  if (!anchor) {
    return '';
  }
  const normalizedAnchor = anchor.startsWith('#/')
    ? anchor.replace('#/', '#')
    : anchor;

  return normalizedAnchor;
};

export const validateAndStoreRedirection = (
  redirectionString: string | string[],
  storageField: string,
  urlAnchor?: string
): void => {
  if (!redirectionString?.[1]) {
    return;
  }

  const redirectTokenString = redirectionString[1];
  const encodedSlash = ['%2F', '%2f'];

  const containsEncodedSlash = new RegExp(encodedSlash.join('|'), 'gi').test(
    redirectTokenString
  );

  let decodedRedirectToken: string;
  try {
    decodedRedirectToken = decodeURIComponent(redirectTokenString);
  } catch {
    decodedRedirectToken = redirectTokenString;
  }

  if (containsEncodedSlash) {
    decodedRedirectToken = decodedRedirectToken.replace(/%2F|%2f/gi, '/');
  }

  if (urlAnchor) {
    const normalizedAnchor = normalizeAnchor(urlAnchor);

    if (validUrlAnchors.includes(normalizedAnchor)) {
      decodedRedirectToken = `${decodedRedirectToken}${normalizedAnchor}`;
    }
  }

  saveToStorage(storageField, decodedRedirectToken);
  if (storageField === 'redirect_url') {
    persistPostAuthRedirectFromRaw(decodedRedirectToken);
  }
  window.history.replaceState({}, document.title, '/');
};
